import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { Color, Spacing, Grid, Media } from '../../theme';
import { HeaderH3 } from '../../uiComponents';
import { styleWhenTrue } from '../../utils';

import { ImagesSectionContentContainerData } from './imagesSectionContent.types';

export const Container = styled.div<ImagesSectionContentContainerData>`
  display: flex;
  justify-content: space-between;
  max-width: ${Grid.DesktopWide};
  margin: 0 auto;
  overflow-y: hidden;
  & + & {
    margin-top: 100px;
  }
  ${Media.tablet`
    flex-direction: column;
    align-items: flex-start;
  `}
  ${styleWhenTrue(prop('reverseOnMobile'), css`
    ${Media.tablet`
      flex-direction: column-reverse;
      align-items: flex-end;
      overflow-x: hidden;
    `}
  `)}
`;

export const Image = styled.img`
  max-width: 100%;
`;

export const ContentSection = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  margin-right: ${Spacing.DesktopWide};
  margin-left: ${Spacing.DesktopWide};
  max-width: 600px;
  width: calc(100% - 2 * ${Spacing.DesktopWide});
  ${Media.desktop`
    margin-right: ${Spacing.Desktop};
    margin-left: ${Spacing.Desktop};
    max-width: calc(100% - 2 * ${Spacing.Desktop});
  `}
  ${Media.tablet`
    margin: 60px ${Spacing.Tablet} 0;
    max-width: calc(100% - 2 * ${Spacing.Tablet});
    width: 100%;
  `}
`;

export const StyledHeaderH3 = styled(HeaderH3)`
  margin: 15px 0 30px;
  ${Media.desktop`
    font-size: 35px;
    letter-spacing: 0.16px;
    line-height: 46px;
  `}
`;

export const ColorBar = styled.div`
  height: 45px;
  background-color: ${Color.secondary};
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentSectionButton = styled.button`
  a {
    color: ${Color.black};
    text-decoration: none;
  }
  border-bottom: 1px solid ${Color.black};
  padding: 0 0 5px;
`;
